module.exports = __webpack_public_path__ + "img/screensaver.79d120a4.png";